<template>
  <router-link :to="to" v-slot="{}" custom>
    <li
      @click="navigate"
      :class="{
        'router-link-active': isActive,
        'router-link-exact-active': isExactActive,
        'disabled': disabled
      }"
    >
      <slot></slot>
    </li>
  </router-link>
</template>

<script>
/**
 * A <router-link> based on the <li> tags instead of <a>.
 */
export default {
  name: 'router-link-li',
  props: {
    to: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigate () {
      if (this.disabled) return;
      this.$router.push(this.to);
    },
  },
  computed: {
    /**
     * v-slot="{ isActive }" dose not work on mount for some reason
     * so this re-implements it.
     */
    isActive () {
      return this.$route.name?.startsWith(this.to.name);
    },
    /**
     * v-slot="{ isExactActive }" dose not work on mount for some reason
     * so this re-implements it.
     */
    isExactActive () {
      return this.$route.name === this.to.name;
    },
  },
};
</script>
